import { persistor } from "../../app/store";

export const handleLogout = () => {
  persistor
    .purge()
    .then(() => persistor.flush())
    .then(() => {
      window.location.href = '/login'; // Redirect to the login page after logout
    });
};